import { FC, PropsWithChildren } from 'react';
import CalculatorProvider from '../CalculatorProvider';
import LayoutContent from './LayoutContent';
import LoanApplicationProcessProvider from './LoanApplicationProcessProvider';

const LoanApplicationProcessLayout: FC<PropsWithChildren> = (props) => (
  <LoanApplicationProcessProvider>
    <CalculatorProvider>
      <LayoutContent>{props.children}</LayoutContent>
    </CalculatorProvider>
  </LoanApplicationProcessProvider>
);

export default LoanApplicationProcessLayout;
